import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

import { Loader, Popconfirm, Button } from '@smartplatform/ui';
import store from '../../../store';
import { formatDateStr } from '../../../utils';

@inject('store') @observer
export default class StageEdit extends React.Component {

	@observable protocol = null;
	@observable deputies = [];
	@observable type = null;
	@observable customType = null;
	@observable isLoading = false;
	@observable isDeleting = false;
	
	constructor(props) {
		super(props);
		this.store = props.store;
		this.isAdmin = store.model.roles ? store.model.roles.findIndex(role => ['admin','protocolist'].includes(role.name)) !== -1 : false;
	}
	
	delete = async () => {
		this.isDeleting = true;
		const { stage, onDelete } = this.props
		console.log('deleting stage', stage);
		const votes = await stage.votes();
		await Promise.all(votes.map(r => r.delete()));
		console.log('deleted votes', votes.length);
		const members = await store.model.SessionMember.find({
			where: {
				and: [
					{ date: stage.voteStart },
					{ sessionId: stage.sessionId },
				]
			}
		});
		await Promise.all(members.map(r => r.delete()));
		console.log('deleted members', members.length);
		await stage.delete();
		await onDelete();
		this.isDeleting = false;
	};
	
	render() {
		const { stage } = this.props;
		
		return <div className="stage-edit">
			<div className="stage-info">
				<div className="type">[{stage.id}] {stage.type ? stage.type.name : (stage.customType || '-')}</div>
				<div className="time">{formatDateStr(stage.voteStart, 'HH:mm:ss')} - {formatDateStr(stage.voteEnd, 'HH:mm:ss')}</div>
				<div className="present">Всего: <span>{stage.present}</span></div>
				<div className="yes">За: <span>{stage.yesCount}</span></div>
				<div className="no">Против: <span>{stage.noCount}</span></div>
				<div className="abstained">Воздерж.: <span>{stage.abstainCount}</span></div>
				<div className="not-voted">Не голосовал: <span>{stage.present - stage.yesCount - stage.noCount - stage.abstainCount}</span></div>
				<div className="result">{stage.statusId === 1 ? 'Принято' : 'Не принято'}</div>
			</div>
			<div className='stage-right'>
			{this.isAdmin && <>
				{!this.isDeleting ?
						<Popconfirm content="Удалить?" onConfirm={this.delete}>
							<Button className="btn-danger btn-sm">Удалить</Button>
						</Popconfirm>
					:
					<><Loader size={18} /> Идет удаление, подождите...</>
				}
			</>}
			<a target="_blank" href={`/active-session/${this.store.session.id}/protocol/${stage.id}`}>Протокол</a>
			</div>
		</div>;
	}
}
